// iter v28 r320 — Lista dei campi obbligatori per pubblicare un annuncio
// su Immobiliare.it / Idealista. Centralizzata qui per essere riusata da:
//  - PropertyEditModal (badge "obbligatorio" + counter "X/Y completi")
//  - extension/content/helper.js (avviso "Mancano: ..." prima di compilare)
//  - Eventuali futuri check di validazione pre-pubblicazione.

export const IMMOBILIARE_REQUIRED_FIELDS = [
  { key: "surface", label: "Superficie" },
  { key: "rooms", label: "Locali totali" },
  { key: "bathrooms", label: "Bagni" },
  { key: "floor", label: "Piano" },
  { key: "total_floors", label: "Piani totali edificio" },
  { key: "energy_class", label: "Classe energetica" },
  { key: "ipe", label: "IPE (kWh/m²anno)" },
  { key: "year_built", label: "Anno di costruzione" },
  { key: "condition", label: "Stato dell'immobile" },
  { key: "heating", label: "Riscaldamento" },
  { key: "cadastral_category", label: "Categoria catastale" },
];

// iter v28 r321 — Campi obbligatori per Idealista (verificati dagli screenshot
// del wizard /flow/pubblica-annuncio?execution=e1s1 + e1s3, raccolti 24/05/2026).
// Idealista è più snello di Immobiliare: NON chiede year_built, total_floors,
// cadastral_category né heating. Però chiede condition (radio "Da ristrutturare /
// Buono stato") che su Immobiliare è facoltativo.
export const IDEALISTA_REQUIRED_FIELDS = [
  { key: "surface", label: "Superficie (m² commerciali)" },
  { key: "rooms", label: "Numero di locali" },
  { key: "bathrooms", label: "Numero di bagni" },
  { key: "floor", label: "Piano" },
  { key: "energy_class", label: "Classe energetica" },
  { key: "condition", label: "Stato (Da ristrutturare / Buono stato)" },
];

// Helper: data una property, ritorna { compiled, missing, total }
export function checkImmobiliareCompleteness(property) {
  return checkPortalCompleteness(property, IMMOBILIARE_REQUIRED_FIELDS);
}

export function checkIdealistaCompleteness(property) {
  return checkPortalCompleteness(property, IDEALISTA_REQUIRED_FIELDS);
}

function checkPortalCompleteness(property, fields) {
  if (!property) return { compiled: 0, missing: [], total: fields.length };
  const missing = [];
  let compiled = 0;
  for (const f of fields) {
    const v = property[f.key];
    const filled = v !== null && v !== undefined && v !== "" && !(typeof v === "number" && isNaN(v));
    if (filled) compiled++;
    else missing.push(f);
  }
  return { compiled, missing, total: fields.length };
}
